import {
  Dialog,
  DialogTitle,
  Divider,
  Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
  TableHead, TablePagination, TableRow, ToggleButton, Typography,
} from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PlaceService from "../../../Services/place/PlaceService";
import Home from "../../home/Home";
import Snacbar from '../../Snacbar';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.black,
    textAlign: "center",
    padding: theme.spacing(0.5),
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 12,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%", fontFamily: 'Times New Roman',
}));

function Country() {
  const mystyle = {
    border: " 1px solid black",
    width: "12rem",
    fontWeight: 'bold', fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "red", fontFamily: 'Times New Roman',
  };
  const [values, setValues] = useState({
    countryId: '',
    coun_name: '',
    coun_code: '',
    phn_code: '',
  });

  const [error, setError] = useState({ countryName: false, countryCode: false, phoneCode: false });
  const [saveDsa, setSaveDsa] = useState(false);
  const [updateDsa, setUpdateDsa] = useState(true);
  const [deleteDsa, setDeleteDsa] = useState(true);

  const [Cntrydelete, setDelete] = useState(false);
  const [save, setSave] = useState(false);
  const [update, setUpdate] = useState(false);

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [details, setDetails] = useState([]);
  const [Filtereddetails, setFiltereddetails] = useState([]);

  //onChange
  const coun_namehandlechange = (e) => {
    setValues({ ...values, coun_name: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const coun_codehandlechange = (e) => {
    setValues({ ...values, coun_code: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const phn_codehandlechange = (e) => {
    setValues({ ...values, phn_code: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };

  const deleteicon = () => {
    return <DeleteOutlineRoundedIcon style={{ color: 'red' }} />
  }
  const getproductdata = async () => {
    PlaceService.getCountryName().then((res) => {
      setDetails(res.data);
      setFiltereddetails(res.data);
    })
  }
  useEffect(() => {
    // const getproductdata = async () => {
    //   PlaceService.getCountryName().then((res) => {
    //     setDetails(res.data);
    //     setFiltereddetails(res.data);
    //   })
    // }
    getproductdata();
  }, []);

  const EditCountryDetails = (item) => {
    setValues({
      ...values, countryId: item.countryId, coun_name: item.countryName, coun_code: item.countryCode,
      phn_code: item.phoneCode
    });
    setSaveDsa(true);
    setUpdateDsa(false);
    setDeleteDsa(false);
    setDelete(false);
    setSave(false);
    setUpdate(false);
  }

  // handelclocse/Opens
  const handleClose = () => {
    setOpen(false);
  }

  //clickEventes

  const validate = () => {
    if (values.coun_name !== '') {
      if (values.coun_code !== '') {
        if (values.phn_code !== '') {
          return true;
        } else {
          document.getElementById('PhoneCode').focus();
          setError({ ...error, phoneCode: true });
          setOpen(true); setSeverity('warning'); setMessage('Please Enter the PhoneCode..!');
        }
      } else {
        document.getElementById('countryCode').focus();
        setError({ ...error, countryCode: true });
        setOpen(true); setSeverity('warning'); setMessage('Please Enter the CountryCode..!');
      }
    } else {
      document.getElementById('countryName').focus();
      setError({ ...error, countryName: true });
      setOpen(true); setSeverity('warning'); setMessage('Please Enter the CountryName..!');
    }
    return false;
  }

  const SaveCountry = () => {
    if (validate() === true) {
      setSaveDsa(true);
      setSave(true);
      let details = { countryName: values.coun_name, countryCode: values.coun_code, phoneCode: values.phn_code }
      PlaceService.insertCountryName(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Insertion Failed');
        } refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    }
  }

  const UpdateCountry = () => {
    if (validate() === true) {
      if (values.countryId !== '') {
        setUpdateDsa(true);
        setUpdate(true);
        let details = { countryId: values.countryId, countryName: values.coun_name, countryCode: values.coun_code, phoneCode: values.phn_code }
        PlaceService.updateCountryName(details).then((res) => {
          const message = res.data.message;
          if (message.toString() === 'SUCCESS') {
            setOpen(true); setSeverity('success'); setMessage(message);
          } else {
            setOpen(true); setSeverity('error'); setMessage('Updation Failed');
          } refresh();
        }).catch(error => {
          setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
        })
      } else {
        setOpen(true); setSeverity('warning'); setMessage('Please Select a Country..!'); refresh();
      }
    }
  }

  const deleteCountry = () => {
    if (validate() === true) {
      if (values.countryId !== '') {
        setDeleteDsa(true);
        setDelete(true)
        setalertopen(true)
      } else {
        setOpen(true); setSeverity('warning'); setMessage('Please Select a Country..!'); refresh();
      }
    }
  }

  const refresh = () => {
    setPage(0)
    setValues({ ...values, countryId: '', coun_name: '', coun_code: '', phn_code: '', cntryCdSrch: '', cntryNameSrch: '' });
    setError({ countryName: false, countryCode: false, phoneCode: false });
    setSaveDsa(false);
    setUpdateDsa(true);
    setDeleteDsa(true);
    setDelete(false);
    setSave(false);
    setUpdate(false);
    getproductdata();
  }
  const cntryNameSrch = () => {
    return <input className="searchBoxes" onChange={(e) => { CountryNMsearch(e.target.value) }} placeholder="Search" />
  }
  const cntryCdSrch = () => {
    return <input className="searchBoxes" onChange={(e) => { CountryCDsearch(e.target.value) }} placeholder="Search" />
  }
  ///
  const CountryNMsearch = (searchedVal) => {
    const FilterValues = details.filter((trns) => {
      return trns.countryName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (searchedVal.length < 1) {
      setFiltereddetails(details)
    } else {
      setFiltereddetails(FilterValues)
    }
  }
  const CountryCDsearch = (serachedVal) => {
    const FilterValues = details.filter((trns) => {
      return trns.countryCode.toString().toLowerCase().includes(serachedVal.toLowerCase())
    })
    if (serachedVal.length < 1) {
      setFiltereddetails(details)
    } else {
      setFiltereddetails(FilterValues)
    }
  }
  ///
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  //--------------dialogBox_KeyDown---------------------//
  const [QuryIndex, setQuryIndex] = useState(0);
  const isImportQuerySelected = (imprter) => QuerImptrSelect.indexOf(imprter) !== -1

  const countrytableDown = (e) => {
    if (e.key === 'ArrowDown') {
      const myData = Filtereddetails.map((node) => node);
      let selectDetails = [];
      selectDetails = (QuerImptrSelect, myData[QuryIndex + 1].countryName)
      setQuerImptrSelect(selectDetails)
      setQuryIndex(QuryIndex + 1);
    } if (e.key === 'ArrowUp') {
      const myData = Filtereddetails.map((node) => node);
      let selectDetails = [];
      selectDetails = (QuerImptrSelect, myData[QuryIndex - 1].countryName);
      setQuerImptrSelect(selectDetails);
      setQuryIndex(QuryIndex - 1);
    }
  }
  // OnClickEvents...
  const [QuerImptrSelect, setQuerImptrSelect] = useState([]);

  //alertbox
  const [alertopen, setalertopen] = useState(false);

  const alertonClickOpen = (item) => {
    setalertopen(true)
    setValues({ ...values, countryId: item.countryId })
  }

  const alertNoOnClick = () => {
    refresh();
    setalertopen(false)
  }

  const alertYesOnClick = () => {
    PlaceService.deleteCountryName(values.countryId).then((res) => {
      const message = res.data.message;
      if (message.toString() === 'SUCCESS') {
        setOpen(true); setSeverity('success'); setMessage(message);
      } else {
        setOpen(true); setSeverity('error'); setMessage('Failed To Delete');
      } alertNoOnClick();
    }).catch(error => {
      setOpen(true); setSeverity('error'); setMessage(error.message); alertNoOnClick()
    })
    setalertopen(false)

  }
  const navigate = useNavigate();
  const BackBotton = () => {
    navigate('/home');
  }
  const ForwordBotton = () => {
    navigate('/State');
  }

  return (
    <div>
      <Dialog open={alertopen}>
        <DialogTitle>
          <center style={{ fontFamily: 'Times New Roman' }}><h6>ARE YOU SURE,</h6></center>
          <h6 style={{ fontFamily: 'Times New Roman' }}>YOU WANT TO DELETE ?</h6>
          <Divider color="#FDA228" sx={{ height: 2 }} />
        </DialogTitle>
        <div className="form-inline p-1">
          <center><Button variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px' }} onClick={alertYesOnClick}>Yes</Button>&nbsp;
            <Button variant="success" className="p-1 mb-2 " style={{ width: '50px' }} onClick={alertNoOnClick}>No</Button></center>
        </div>
      </Dialog>
      <Home />
      <Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid item xs={4} style={{ marginTop: "1rem" }}>
              <Row xs={3}>
                <Col xs={1}>
                </Col>
                <Col xs={11}><Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"} style={{ fontFamily: 'Times New Roman' }}>
                  Country Details Entry
                </Typography></Col>
              </Row>

              <hr></hr>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>CountryName*</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} isInvalid={error.countryName} id='countryName'
                    value={values.coun_name} onChange={coun_namehandlechange} required />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>CountryCode*</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} value={values.coun_code} id='countryCode'
                    onChange={coun_codehandlechange} isInvalid={error.countryCode} required />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>PhoneCode*</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="number" style={mystyle} isInvalid={error.phoneCode} required
                    value={values.phn_code} onChange={phn_codehandlechange} id='PhoneCode' />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={1}></Col>
                <Col lg={10}>
                  <Button style={{ fontFamily: 'Times New Roman' }} size="sm" disabled={saveDsa} onClick={SaveCountry}>
                    {save ? 'processing..' : 'Save'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman' }} variant="info" size="sm" disabled={updateDsa} onClick={UpdateCountry}>
                    {update ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman' }} variant="danger" size="sm" disabled={deleteDsa} onClick={deleteCountry}>
                    {Cntrydelete ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman' }} variant="secondary" size="sm" onClick={refresh}>
                    Refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid item xs={8} style={{ marginTop: "1rem" }}>
              <ItemPap1>
                <Row>
                  <Col xs={11}>
                    <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"} style={{ fontFamily: 'Times New Roman' }}>
                      Existing Country Details
                    </Typography>
                  </Col>
                  <Col></Col>
                  <Col>
                  </Col>
                </Row>
                <TableContainer sx={{ height: 360, maxHeight: 360 }} style={{ marginTop: "1px" }}>
                  <Table stickyHeader >
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell style={{ width: '5%', textAlign: 'center' }}>SlNo</StyledTableCell>
                        <StyledTableCell style={{ width: '35%', textAlign: 'center' }} >Country Name {cntryNameSrch()}</StyledTableCell>
                        <StyledTableCell style={{ width: '35%', textAlign: 'center' }} >Country Code {cntryCdSrch()}</StyledTableCell>
                        <StyledTableCell style={{ width: '20%', textAlign: 'center' }} >Phone_Code</StyledTableCell>
                        <StyledTableCell style={{ width: '5%', textAlign: 'center' }} >Actions</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {Filtereddetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((item, index) => {
                          const itemSelectdImp = isImportQuerySelected(item.countryName)
                          return (
                            <TableRow onKeyDown={countrytableDown} hover onClick={() => EditCountryDetails(item, index)}
                              key={item.serialNumber} tabIndex={-1} selected={itemSelectdImp}>
                              <StyledTableCell style={{ textAlign: 'center' }}>{item.serialNumber}</StyledTableCell>
                              <StyledTableCell style={{ textAlign: 'center' }}>{item.countryName}</StyledTableCell>
                              <StyledTableCell style={{ textAlign: 'center' }}>{item.countryCode}</StyledTableCell>
                              <StyledTableCell style={{ textAlign: 'center' }}>{item.phoneCode}</StyledTableCell>
                              <StyledTableCell style={{ textAlign: 'center' }}><span onClick={() => alertonClickOpen(item)}>{deleteicon()}</span></StyledTableCell>
                            </TableRow>)
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  component='div'
                  count={Filtereddetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default Country;
